<template>
  <div>
    <a-row>
          <g-master name="forms_components"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :parentData="parentData"
                    :modalFieldsSetup="master.modalFieldsSetup"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Valor')">
                    <a-input
                      v-decorator="['value', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Etiqueta')">
                    <a-input
                      v-decorator="['label', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Orden')">
                    <a-input
                      v-decorator="['orden', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Estado')" :has-feedback="false">
                    <a-checkbox
                      v-decorator="['status', {valuePropName: 'checked',  rules: [{ required: true, message: 'Valor requerido'}]}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
    </a-row>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        tipo_componente: {
          h_lookup_type: 'CIUDADES_HV'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'forms_comp_options',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Valor', dataIndex: 'value', sorter: true},
              {title: 'Etiqueta', dataIndex: 'label', sorter: true},
              {title: 'Orden', dataIndex: 'orden', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'value'},
            {name: 'label'},
            {name: 'orden'},
            {name: 'status', type: 'boolean'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_component: this.id
        }
      }
    },
    props: ['id']
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Form/FormsCompOptions.vue